import { render, staticRenderFns } from "./mo-dialog.html?vue&type=template&id=32e31b7d&external"
import script from "./mo-dialog.ts?vue&type=script&lang=ts&external"
export * from "./mo-dialog.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/agent/_work/5/s/Be.Vlaanderen.Mo.Vue/ClientApp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('32e31b7d')) {
      api.createRecord('32e31b7d', component.options)
    } else {
      api.reload('32e31b7d', component.options)
    }
    module.hot.accept("./mo-dialog.html?vue&type=template&id=32e31b7d&external", function () {
      api.rerender('32e31b7d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/shared/mo-dialog/mo-dialog.vue"
export default component.exports